import PopSlider from '../PopSlider/PopSlider';
import { Wrapper } from './Lod.style';

export type LodProps = {
  lod: number;
  onChange: (value: string | number) => void;
  onSet: (value: string | number) => void;
};

export function Lod(props: LodProps) {
  const { lod } = props;

  return (
    <Wrapper className='Lod-wrapper' data-testid='Lod-wrapper'>
      <PopSlider
        colorValue=''
        header='LOD'
        position='right'
        value={lod}
        iconName='IconViewfinder'
        onChange={props.onChange}
        onSet={props.onSet}
        defaultValues={{ intensity: 0.5, color: '' }}
        hideColor
      />
    </Wrapper>
  );
}

export default Lod;
